import { render } from "./GreyContainer.vue?vue&type=template&id=8551aa2c"
import script from "./GreyContainer.vue?vue&type=script&lang=js"
export * from "./GreyContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__